<template>
  <div class='massLoss-list' v-loading='importLoading'>
    <div class='nav'>
      <el-form ref='searchFormRef' :model='searchForm' label-width='140px' :inline='true'
               class='demo-form-inline flex1'>
        <el-form-item label='业务编号：'>
          <el-input v-model='searchForm.businessNo' size='mini' placeholder='请输入业务编号' />
        </el-form-item>
        <el-form-item label='业务单位：'>
          <el-select v-model='searchForm.businessUnit' clearable filterable size='mini'
                     placeholder='请选择业务单位'>
            <el-option :label='"全部"' value='' />
            <el-option v-for='item in selectedData.attrList1' :key='item.id'
                       :label='item.classaName' :value='item.classaName' />
          </el-select>
        </el-form-item>
        <el-form-item label='业务类型：'>
          <el-select v-model='searchForm.businessType' clearable filterable size='mini'
                     placeholder='请选择业务单位'>
            <el-option :label='"全部"' value='' />
            <el-option v-for='item in selectedData.attrList2' :key='item.id'
                       :label='item.classaName' :value='item.classaName' />
          </el-select>
        </el-form-item>
        <el-form-item label='业务板块：'>
          <el-select v-model='searchForm.businesSegment' clearable filterable size='mini'
                     placeholder='请选择业务板块'>
            <el-option :label='"全部"' value='' />
            <el-option v-for='item in selectedData.attrList3' :key='item.id'
                       :label='item.classaName' :value='item.classaName' />
          </el-select>
        </el-form-item>
        <el-form-item label='联运类型：'>
          <el-select v-model='searchForm.transportType' clearable filterable size='mini'
                     placeholder='请选择联运类型'>
            <el-option :label='"全部"' value='' />
            <el-option v-for='item in selectedData.attrList4' :key='item.id'
                       :label='item.classaName' :value='item.classaName' />
          </el-select>
        </el-form-item>
        <el-form-item label='货类：'>
          <el-select v-model='searchForm.goods' clearable filterable size='mini'
                     placeholder='请选择货类'>
            <el-option :label='"全部"' value='' />
            <el-option v-for='item in selectedData.attrList5' :key='item.id'
                       :label='item.classaName' :value='item.classaName' />
          </el-select>
        </el-form-item>
        <el-form-item label='是否固定资产业务：'>
          <el-select v-model='searchForm.fixedBusiness' clearable filterable size='mini'
                     placeholder='请选择是否固定资产业务'>
            <el-option :label='"全部"' value='' />
            <el-option v-for='item in selectedData.attrList8' :key='item.id'
                       :label='item.classaName' :value='item.classaName' />
          </el-select>
        </el-form-item>
        <el-form-item label='状态：'>
          <el-select v-model='searchForm.type' clearable filterable size='mini'
                     placeholder='请选择状态'>
            <el-option :label='"全部"' value='' />
            <el-option :label='"待提交"' :value='0' />
            <el-option :label='"已提交"' :value='1' />
            <el-option :label='"退回"' :value='2' />
          </el-select>
        </el-form-item>
        <el-form-item label='起止时间：'>
          <!--          <el-date-picker v-model='searchForm.years' size='mini'
                                    value-format='yyyyMM' type='month' placeholder='请选择年月' />-->
          <el-date-picker v-model='searchForm.settlementStartYears' size='mini' style='width:150px'
                          value-format='yyyyMM' @change='dateChange' type='month'
                          placeholder='开始日期' />
          <span style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
          <el-date-picker v-model='searchForm.settlementEndYears' size='mini' style='width:150px'
                          value-format='yyyyMM' @change='dateChange' type='month'
                          placeholder='结束日期' />
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' class='searchBtn' @click='btnClick("add")'>新增</el-button>
          <el-button size='small' class='searchBtn' @click='btnClick("submitSummary")'>提交汇总
          </el-button>
          <el-button size='small' class='searchBtn' @click='btnClick("refresh")'>月度刷新
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <div style='display: flex;justify-content: flex-end;'>
          <span @click='download'>模板下载</span>
          <batch-import :uploadUrl='uploadUrl' @importSuccess='searchBtn'
                        @triggerLoading='importLoading = !importLoading' />
          <span @click='exportData'>导出数据</span>
        </div>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          ref='registerTable'
          row-key='id'
          v-loading='tableLoading'
          :data='tableData'
          style='width: 100%'
          :max-height='tableMaxHeight'
          border
          :header-cell-style='headerCellStyle'
          @select='handleCurrentChange'
          @select-all='handleCurrentChange'
          :row-style="rowStyle"
        >
          <el-table-column type='selection' align='center' width='50px' :reserve-selection='true'
                           :selectable='(row)=>{return row.type !== 1}' />
          <el-table-column prop='consignorName' label='委托商' align='center' min-width='180' show-overflow-tooltip/>
          <el-table-column prop='businessNo' label='业务编号' align='center' min-width='180' />
          <el-table-column prop='years' label='时间' align='center' min-width='80' />
          <el-table-column prop='businessUnit' label='业务单位' align='center' min-width='120' />
          <el-table-column prop='businessType' label='业务类型' align='center' min-width='120' />
          <el-table-column prop='businesSegment' label='业务板块' align='center' min-width='120' />
          <el-table-column prop='transportType' label='联运类型' align='center' min-width='120' />
          <el-table-column prop='goods' label='货类' align='center' min-width='120' />
          <el-table-column prop='businessSource' label='业务来源' align='center' min-width='80' />
          <el-table-column prop='customerIndustry' label='客户行业' align='center' min-width='200' />
          <el-table-column prop='fixedBusiness' label='是否固定资产业务' align='center' min-width='140' />
          <el-table-column prop='meteringCompany' label='计量单位' align='center' min-width='200' />
          <el-table-column prop='businessVolume' label='业务量' align='center' min-width='80' />
          <el-table-column prop='weight' label='重量' align='center' min-width='80' />
          <el-table-column prop='taxExcluded' label='不含税收入' align='center' min-width='120' />
          <el-table-column prop='packageAttribute' label='下包属性' align='center' min-width='80' />
          <el-table-column prop='remarks' label='备注' align='center' min-width='80' />
          <!-- 循环开始 -->
          <div v-for='(item, index) in brand' :key='index'>
            <el-table-column :prop='`businessVolume${index+1}`' :label='`业务量${index+1}`'
                             align='center' min-width='80' />
            <el-table-column :prop='`weight${index+1}`' :label='`重量${index+1}`'
                             align='center' min-width='80' />
            <el-table-column :prop='`taxExcluded${index+1}`' :label='`不含税收入${index+1}`'
                             align='center' min-width='120' />
            <el-table-column :prop='`logisticsMode${index+1}`' :label='`物流方式${index+1}`'
                             align='center' min-width='120' />
            <el-table-column :prop='`logisticsTools${index+1}`' :label='`物流工具${index+1}`'
                             align='center' min-width='120' />
            <el-table-column :prop='`logisticsAttribute${index+1}`' :label='`物流属性${index+1}`'
                             align='center' min-width='120' />
            <el-table-column prop='accountPrice1' label='一次暂估价' align='center' min-width='80' />
            <el-table-column prop='accountTime1' label='一次暂估时间' align='center' min-width='80' />
            <el-table-column prop='accountPrice2' label='二次暂估价' align='center' min-width='80' />
            <el-table-column prop='accountTime2' label='二次暂估时间' align='center' min-width='80' />
            <el-table-column prop='accountPrice3' label='三次暂估价' align='center' min-width='80' />
            <el-table-column prop='accountTime3' label='三次暂估时间' align='center' min-width='80' />
            <el-table-column prop='accountPrice4' label='调账价' align='center' min-width='80' />
            <el-table-column prop='accountTime4' label='调账时间' align='center' min-width='80' />
            <el-table-column prop='accountPrice5' label='对账调整价' align='center' min-width='80' />
            <el-table-column prop='accountTime5' label='对账调整时间' align='center' min-width='80' />
            <el-table-column prop='accountPriceTotal' label='最终价' align='center' min-width='80' />
          </div>
          <!-- 循环结束 -->
          <el-table-column prop='type' label='状态' align='center' min-width='80'>
            <template slot-scope='scope'>
              {{ scope.row.type === 0 ? '待提交' : scope.row.type === 1 ? '已提交' : '退回' }}
            </template>
          </el-table-column>
          <el-table-column label='操作' fixed='right' width='220px' align='center'>
            <template slot-scope='scope'>
              <el-button size='mini' type='primary' @click='btnClick("info",scope.row)'>详情
              </el-button>
              <el-button size='mini' v-if='scope.row.type !== 1' type='warning'
                         @click='btnClick("edit",scope.row)'>修改
              </el-button>
              <el-button size='mini' v-if='scope.row.type !== 1' type='info'
                         @click='btnClick("delete",scope.row)'>删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>

    <!-- 新增/编辑 -->
    <month-form ref='monthFormRef' @searchBtn='searchBtn' />
    <!-- 详情 -->
    <month-info ref='monthInfoRef' />
  </div>
</template>

<script>
  import {
    monthlySummaryMonthDelete,
    monthlySummaryMonthPage, monthlySummaryMonthQuery, monthlySummaryMonthRefresh,
    monthlySummaryMonthSubmit,
  } from '@/service/financial';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import MonthForm from './monthForm';
  import MonthInfo from './monthInfo';
  import BatchImport from '@/components/batchImport';

  export default {
    name: 'month',
    components: {
      BatchImport,
      MonthForm,
      MonthInfo,
    },
    data() {
      return {
        importLoading: false,
        searchForm: {
          businessNo: '',
          settlementStartYears: '',
          settlementEndYears: '',
          businessUnit: '',
          businessType: '',
          businesSegment: '',
          transportType: '',
          goods: '',
          fixedBusiness: '',
          type: '',
          page: 1,
          rows: 10,
        },
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        total: 0,
        dateType: 0,
        brand: [],
        checkTableData: [],
        uploadUrl: '/monthly/summary/month/portBatchQueryId',
        windowHeight: 0,
        tableMaxHeight: 550,
        selectedData: {},
      };
    },
    watch: {
      windowHeight() {
        this.getResolution(true);
      },
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      this.getSelectedData();
      // this.searchBtn();
      this.getResolution();
    },
    methods: {
      async getSelectedData() {
        const {
          status,
          message,
          data,
        } = await monthlySummaryMonthQuery();
        if (status !== 0) return this.message.warning(message);
        this.selectedData = data;
      },
      getResolution(flag) {
        if (flag) {
          this.windowHeight === 1080 ? this.tableMaxHeight = 550 : this.tableMaxHeight = 300;
          this.$forceUpdate();
          return;
        }
        this.windowHeight = window.screen.height;
      },
      async btnClick(str, row) {
        switch (str) {
          case 'add':
            this.$refs.monthFormRef.dialogOpen('新增');
            break;
          case 'edit':
            this.$refs.monthFormRef.dialogOpen('编辑', row.id);
            break;
          case 'info':
            console.log(row.id);
            this.$refs.monthInfoRef.dialogOpen(row.id);
            break;
          case 'delete':
            this.$confirm('确认删除当前数据吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            })
              .then(async () => {
                const {
                  status,
                  message,
                } = await monthlySummaryMonthDelete(row.id);
                if (status !== 0) return this.$message.warning(message);
                this.$message.success(message);
                await this.getTableData();
              })
              .catch();
            break;
          case 'submitSummary':
            if (this.checkTableData === null || this.checkTableData.length === 0) return this.$message.warning('请选择数据后提交汇总');
            this.$confirm('确认提交当前选中数据吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            })
              .then(async () => {
                const ids = [];
                this.checkTableData.forEach(item => {
                  ids.push(item.id);
                });
                const {
                  status,
                  message,
                } = await monthlySummaryMonthSubmit({ ids });
                if (status !== 0) return this.$message.warning(message);
                this.$message.success(message);
                await this.clearCheckTableData();
              })
              .catch();
            break;
          case 'refresh':
            this.importLoading = true;
            const {
              status,
              message,
            } = await monthlySummaryMonthRefresh();
            this.importLoading = false;
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            await this.getTableData();
            break;
        }
      },
      clearCheckTableData() {
        this.$refs.registerTable.clearSelection();
        this.checkTableData = [];
        this.getTableData();
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/monthly/summary/month/export?access_token=${token}&businessNo=${this.searchForm.businessNo}&years=${this.searchForm.years}&businessUnit=${this.searchForm.businessUnit}&businessType=${this.searchForm.businessType}&businesSegment=${this.searchForm.businesSegment}&transportType=${this.searchForm.transportType}&goods=${this.searchForm.goods}&settlementStartYears=${this.searchForm.settlementStartYears}&settlementEndYears=${this.searchForm.settlementEndYears}&fixedBusiness=${this.searchForm.fixedBusiness}&type=${this.searchForm.type}`;
        window.exportExcelGet('/platform/monthly/summary/month/export', `businessNo=${this.searchForm.businessNo}&years=${this.searchForm.years}&businessUnit=${this.searchForm.businessUnit}&businessType=${this.searchForm.businessType}&businesSegment=${this.searchForm.businesSegment}&transportType=${this.searchForm.transportType}&goods=${this.searchForm.goods}&settlementStartYears=${this.searchForm.settlementStartYears}&settlementEndYears=${this.searchForm.settlementEndYears}&fixedBusiness=${this.searchForm.fixedBusiness}&type=${this.searchForm.type}`)
      },
      // 查询
      searchBtn() {
        this.$refs.searchFormRef.validate(async (valid) => {
          if (valid) {
            this.searchForm.page = 1;
            await this.getTableData();
          }
        });
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await monthlySummaryMonthPage(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.brand = data.brand;
        this.$nextTick(async () => {
          await this.$forceUpdate();
          this.tableData = data.data;
          this.total = data.total;
        });
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      // 多选事件触发
      handleCurrentChange(val) {
        this.checkTableData = val;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      //模板下载
      download() {
        window.location.href = '/file/年月汇报月度导入模板.xlsx';
      },
      // 结束时间
      dateChange(val) {
        if (this.searchForm.settlementEndYears && this.searchForm.settlementStartYears && (this.searchForm.settlementEndYears < this.searchForm.settlementStartYears)) {
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
    },
  };
</script>


<style lang='scss' scoped>
  .massLoss-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/

    .tabs {
      //float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 239px;
      margin-bottom: 20px;

      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599E;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599E;
        font-weight: 700;
        transition: all .3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      .right {
        /*width: 160px;*/
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }

      .active {
        background: #48599E;
        color: #fff;
      }
    }

    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }


        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }


    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }

            }

          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }

        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }

    }

  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      margin-right: 10px;
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
